module.exports = __webpack_public_path__ + "static/img/3-info-b1.4ddf2d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3-info-b1.jpg
// module id = RNlF
// module chunks = 0